<template>
  <div
    v-if="isVisible"
    class="!fixed !inset-0 !bg-black/50 !flex !items-center !justify-center !z-[1000] !p-4"
    @click="hide"
  >
    <div
      class="!bg-white !rounded-2xl !max-w-2xl !w-full !h-[80vh] !flex !flex-col !shadow-2xl !relative !overflow-hidden"
      @click.stop
    >
      <div class="!flex !items-center !justify-between !p-5 !border-b !border-gray-200">
        <h2 class="!text-xl !font-semibold !text-gray-900 !m-0">
          Conditions Générales d'Utilisation
        </h2>
        <button
          type="button"
          class="!p-2 !hover:bg-gray-100 !rounded-lg !transition-colors !border-0 !bg-transparent !cursor-pointer text-gray-500"
          @click="hide"
        >
          <span class="!text-xl font-bold">✕</span>
        </button>
      </div>
      <div class="!flex-1 !p-4">
        <iframe
          :src="cguUrl"
          class="w-full h-full rounded-lg border border-neutral-200"
          frameborder="0"
          allowfullscreen
          title="Conditions Générales d'Utilisation"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isVisible = ref(false)
const cguUrl = 'https://www.monrapidoo.com/cgu'

function show() {
  isVisible.value = true
}

function hide() {
  isVisible.value = false
}

defineExpose({ show, hide })
</script>
